<template>
  <div class="foot_container">
    <div class="content_width">
      <div class="top_container">
        <div class="left_content">
          <div v-for="item in leftList" :key="item.text" class="item" @click="goToPage(item)">
            {{item.text}}
          </div>
        </div>
        <div class="middle_content">
          <div class="text">联系方式</div>
          <div class="text">全国咨询热线：{{ contactInfo.phone }}</div>
          <div class="text">客服投诉热线：{{ contactInfo.complaintPhone }}</div>
          <div class="text">战略合作热线：{{ contactInfo.cooperationPhone }}</div>
          <div class="text">QQ在线热线：{{ contactInfo.qq }}</div>
          <div class="text">总部地址：{{ contactInfo.address }}</div>

        </div>
        <div class="right_content">
          <div class="title">好大夫教育</div>
          <div class="text">{{ companyIntro }}</div>
        </div>
      </div>
      <div class="bottom_container">
        <div class="name">{{ contactInfo.companyName }}</div>
        <div class="filing_information">
          {{ contactInfo.copyright }}
        </div>
        <div class="filing_information">
          友情链接：
          <a href="http://www.51yikao.com/" target="_blank" style="margin-right: 8px;">无忧医考网</a>
          <a href="http://www.hdf123.com/" target="_blank" style="margin-right: 8px;">好大夫教育官网</a>
          <a href="http://m.hdf123.com/" target="_blank" >好大夫手机版官方网</a>
        </div>




      </div>

    </div>

  </div>
</template>

<script>

import { getSiteConfigs, getNavigations, getPageBySlug } from '@/api'

export default {
  name: 'Foot_Modules',
  components: {
  },
  data() {
    return {
      leftList:[],
      companyIntro: '',
      contactInfo: {
        phone: '',
        complaintPhone: '',
        cooperationPhone: '',
        qq: '',
        address: '',
        copyright: '',
        icp: '',
        companyName: '',
      },
    }
  },
  async created() {
    await this.loadConfigs()
  },
  methods: {
    goToPage(item) {
      if (item.route_path) {
        this.$router.push({ path: item.route_path, query: { slug: item.slug } }).catch(() => {})
      }
    },
    async loadConfigs() {
      try {
        const configs = await getSiteConfigs()
        if (configs) {
          this.contactInfo.phone = configs.contact_phone || ''
          this.contactInfo.qq = configs.contact_qq || ''
          this.contactInfo.address = configs.contact_address || ''
          this.contactInfo.copyright = configs.copyright || ''
          this.contactInfo.icp = configs.icp_number || ''
          this.companyIntro = configs.about_summary || ''
        }
      } catch (e) { console.log('配置加载失败') }

      try {
        const navs = await getNavigations({ nav_type: 'footer' })
        if (navs && navs.length) {
          this.leftList = navs.map(n => ({
            text: n.name,
            route_path: n.route_path || '/about',
            slug: n.route_path ? n.route_path.replace('/','') : (n.slug || ''),
          }))
        }
      } catch (e) { console.log('底部导航加载失败') }
    },
  }
}
</script>
<style scoped lang="scss">
.foot_container{
  background: #464646;
  padding: 30px 0 40px;
  text-align: left;
  .top_container{
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #fff;
    padding-bottom: 20px;
    border-bottom: 1px solid #575757;
    margin-bottom: 20px;
    .left_content{
      margin-right: 60px;
      .item{
        margin-bottom: 15px;
        cursor: pointer;
      }
    }
    .middle_content{
      margin-right: 40px;
      .text{
        margin-bottom: 15px;
      }
    }
    .right_content{
      width: 550px;
      .title{
        margin-bottom: 15px;
      }
      .text{
        color: #D2D2D2;
        line-height: 25px;
      }
    }
  }
  .bottom_container{
    color: #fff;
    .name{
      font-size: 30px;
      font-weight: 500;
      margin-bottom: 15px;
      text-align: center;
    }
    .filing_information{
      font-size: 14px;
      color: #7b7b7b;
      text-align: center;
      >a{
        color: #7b7b7b;
        display:inline-block;
        text-decoration:none;
      }
    }
  }



}

</style>
